import React from "react";
import { Alert, Box, Button, Link as MuiLink, Typography } from "@mui/material";
import { C } from "../constants/colors";
import AuthLayout from "../layout/AuthLayout";
import { authButtonSx } from "../theme/authStyles";

const OKRION_REGISTER_URL = "https://app.okrion.ai/select-role";

export default function Signup({ goToLogin }) {
  const goToOkrionRegistration = () => {
    window.location.href = OKRION_REGISTER_URL;
  };

  return (
    <AuthLayout
      title="Create your OKRion account"
      subtitle="AI Path Builder access is managed through OKRion. Register there first, then sign in here with the same credentials."
      maxWidth={520}
      footer={
        <>
          Already registered in OKRion?{" "}
          <MuiLink component="button" type="button" onClick={goToLogin} sx={{ fontWeight: 600, color: C.primary }}>
            Sign in
          </MuiLink>
        </>
      }
    >
      <Alert severity="info" sx={{ mb: 2, borderRadius: "10px" }}>
        New user registration is handled only in OKRion to keep your institution, role, and access permissions in sync.
      </Alert>

      <Box
        sx={{
          border: "1px solid rgba(15, 23, 42, 0.08)",
          borderRadius: "14px",
          p: 2,
          mb: 2.5,
          background: "linear-gradient(135deg, rgba(20, 184, 166, 0.08), rgba(14, 165, 233, 0.06))",
        }}
      >
        <Typography sx={{ fontWeight: 700, color: C.text, mb: 1 }}>
          How to get access
        </Typography>
        <Box component="ol" sx={{ m: 0, pl: 2.4, color: C.muted, fontSize: 14, lineHeight: 1.8 }}>
          <li>Select your role in OKRion.</li>
          <li>Complete the OKRion registration or sign in if you already have an account.</li>
          <li>Return to AI Path Builder and use the same OKRion email and password.</li>
        </Box>
      </Box>

      <Button
        type="button"
        fullWidth
        variant="contained"
        onClick={goToOkrionRegistration}
        sx={authButtonSx}
      >
        Register in OKRion
      </Button>

      <Button
        type="button"
        fullWidth
        variant="outlined"
        onClick={goToLogin}
        sx={{
          mt: 1.5,
          borderRadius: "10px",
          borderColor: "rgba(15, 23, 42, 0.14)",
          color: C.text,
          fontWeight: 700,
          textTransform: "none",
          py: 1.2,
        }}
      >
        Back to Sign in
      </Button>
    </AuthLayout>
  );
}
